import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { VgAPI } from 'videogular2/core';
import { TimerService, ApplicationEventService } from '../../../services';
import { MatchEvent, Match, MediaSource } from '../../../models';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'video-player',
  templateUrl: 'video-player.component.html',
  styleUrls: ['./video-player.component.css']
})
export class VideoPlayerComponent implements OnInit {
  @Input() source: MediaSource;
  @Input() allowSlide = true;
  @Input() timer$: Observable<MatchEvent>;
  @Input() playState$: Observable<boolean>;
  @Input() autoPlay = false;

  @Output() currentTime$ = new EventEmitter<number>();
  @Output() readyState$ = new EventEmitter<boolean>();
  api: VgAPI;
  showSlide = true;

  constructor(
    private timerService: TimerService,
    private applicationEventService: ApplicationEventService
  ) {
    applicationEventService.navigateTo$.subscribe((matchEvent: MatchEvent) => {
      this.navigateTo(matchEvent);
    });

    applicationEventService.matchChanged$.subscribe((match: Match) => {
      this.changeMedia(match.media);
    });
  }

  ngOnInit() {
    console.info(`[VideoPlayer]::ngOnInit Setting source`, this.source, this.allowSlide);

    const that = this;
    if (this.timer$) {
      console.info('[VideoPlayer]::ngOnInit subscribing to timer$');
      this.timer$.subscribe(codeEvent => {
        console.info('[VideoPlayer]::ngOnInit timer$: ', codeEvent);
        that.navigateTo(codeEvent);
      });
    }

    if (this.playState$) {
      console.info('[VideoPlayerComponent] subscribing to playState$');
      this.playState$.subscribe(playState => {
        console.info('[VideoPlayerComponent] playState$: ', playState);
        if (playState) {
          this.attemptPlayback();
        } else {
          this.api.pause();
        }
      });
    }

    this.showSlide = this.allowSlide ? this.allowSlide : true;
  }

  onPlayerReady(api: VgAPI) {
    this.api = api;
    console.info('[VideoPlayer]::onPlayerReady vg:loaded');

    this.readyState$.emit(true);

    this.api.getDefaultMedia().subscriptions.timeUpdate.subscribe(() => {
      const currentTime = this.api.currentTime;
      this.timerService.setTime(currentTime);
      this.currentTime$.emit(currentTime);
    });

    this.api.getDefaultMedia().subscriptions.durationChange.subscribe(() => {
      const duration = this.api.duration;
      console.debug(`vg:durationChanged ${duration}`);
      this.applicationEventService.mediaLoaded({ duration: duration });
    });

    if (this.autoPlay) {
      this.attemptPlayback();
    }
  }

  attemptPlayback() {
    const videoElement = this.api.videogularElement.getElementsByTagName('video')[0];
    console.log(videoElement);
    const promise = videoElement.play();
    if (promise !== undefined) {
      promise.then(() => {
        console.trace('[VideoPlayer]::attemptPlayback playing clip');
      }).catch(error => {
        this.api.pause();
        console.debug('[VideoPlayer]::attemptPlayback browser rejected autoplay request.');
      });
    }
  }

  changeMedia(mediaSource: MediaSource) {
    // this.media(mediaSource.src, mediaSource.type);
    console.info(`vg:mediaChanged`);
  }

  navigateTo(matchEvent: MatchEvent): void {

   const leadSeconds = (isNaN(matchEvent.leadSeconds)) ? 5 : matchEvent.leadSeconds;

    let newSeconds = Math.max(matchEvent.seconds - leadSeconds, 0);
    console.info(`vg:navigateTo ${newSeconds}`, matchEvent);

    newSeconds = Math.round(newSeconds);
    this.api.currentTime = newSeconds;
  }

  seekForward(seconds: number) {
    this.api.currentTime += seconds;
  }
}
